import { Checkbox } from '@bloomfieldrobotics/canopy';
import { Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import {
  selectDisableDeveloper,
  selectDisableDiagnostics,
  setDisableDeveloper,
  setDisableDiagnostics,
} from '../../../../services/featureFlags/featureFlagSlice';
import { useFeatureFlags } from '../../../../services/featureFlags/hooks/useFeatureFlags';
import { prettifyFlagKeys } from '../../../../services/featureFlags/utils/prettifyFlagKeys';
import { ToggleSwitch } from '../../../commonUI/ToggleSwitch';
import { SettingsMenuRow } from '../../components/SettingsMenuRow';
import { SettingsPaper } from '../../components/SettingsPaper';

export const FeatureFlagsMenu = () => {
  const featureFlags = useFeatureFlags(true); // raw feature flags
  const prettyFlags = prettifyFlagKeys(featureFlags);

  // Local flag overrides
  const disableDiagnostics = useAppSelector(selectDisableDiagnostics);
  const disableDeveloper = useAppSelector(selectDisableDeveloper);

  const dispatch = useAppDispatch();

  return (
    <SettingsPaper>
      {Object.entries(prettyFlags).map(([flag, LDValue]) => {
        switch (flag) {
          case 'diagnostics':
            return (
              <FeatureFlagRow
                flag={flag}
                LDValue={LDValue}
                isLocallyDisabled={disableDiagnostics}
                onChange={(checked) => {
                  dispatch(setDisableDiagnostics(checked));
                }}
              />
            );
          case 'developer':
            return (
              <FeatureFlagRow
                flag={flag}
                LDValue={LDValue}
                isLocallyDisabled={disableDeveloper}
                onChange={(checked) => {
                  dispatch(setDisableDeveloper(checked));
                }}
              />
            );
          default:
            return <FeatureFlagRow flag={flag} LDValue={LDValue} />;
        }
      })}
    </SettingsPaper>
  );
};

const ReadOnlyCheckbox = ({ checked }: { checked: boolean }) => {
  return <Checkbox checked={checked} readOnly disableRipple />;
};

const FeatureFlagRow = ({
  flag,
  LDValue,
  isLocallyDisabled,
  onChange,
}: {
  flag: string;
  LDValue: boolean;
  isLocallyDisabled?: boolean;
  onChange?: (checked: boolean) => void;
}) => {
  return (
    <SettingsMenuRow key={flag} sx={{ justifyContent: 'space-between' }}>
      <Typography sx={{ textTransform: 'capitalize', width: '100%' }}>
        {flag}
      </Typography>
      {isLocallyDisabled !== undefined && onChange !== undefined && (
        <ToggleSwitch
          label={'disable?'}
          checked={isLocallyDisabled}
          onChange={(e) => onChange(e.target.checked)}
        />
      )}
      <ReadOnlyCheckbox checked={LDValue} />
    </SettingsMenuRow>
  );
};
